import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slide-out";
import Cart from "../Header/Cart/Cart";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalAndMenu = this.closeModalAndMenu.bind(this);
    this.state = {
      open: false,
    };
  }

  closeMenu() {
    this.setState({ open: false });
  }

  openMenu() {
    window.location.href = "/checkout/address";
    this.closeMenu();
  }

  closeModal() {
    $("#mcartModal").modal("hide");
  }

  closeModalAndMenu() {
    $("#mcartModal").modal("hide");
    var that = this;
    setTimeout(function () {
      that.closeMenu();
    }, 500);
  }

  render() {
    return (
      <div className="mobile-navbar">
        <div className="navbar-inner constrict">
          <div className="container">
            <ul
              className="nav"
              style={
                this.state.open ? { overflow: "hidden", height: "80vh" } : {}
              }
            >
              {this.props.itemCount == 0 ? null : (
                <li className="dropdown-li">
                  <button
                    className="unbuttonize slicky abli"
                    onClick={this.openMenu}
                  >
                    <div className="dropdown dd-color">Checkout</div>
                    <i className="fa fa-arrow-right dd-arrow" />
                  </button>
                </li>
              )}
              <Cart
                isMobile={true}
                changeTesting={this.props.changeTesting}
                changeQuantity={this.props.changeQuantity}
                cartSuggestions={this.props.cartSuggestions}
                order={this.props.order}
                emptyCart={this.props.emptyCart}
                checkoutImage={this.props.checkoutImage}
                couponCode={this.props.couponCode}
                deleteItem={this.props.deleteItem}
                international={this.props.checkoutInfo.international}
              />
              <Slider isOpen={this.state.open}>
                <li
                  className="dropdown-li slicky abli"
                  onClick={this.closeMenu}
                >
                  <div className="dropdown dd-color">Shopping Cart</div>
                  <i className="fa fa-arrow-left dd-arrow-left" />
                </li>
              </Slider>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
